<script setup>
import { computed } from 'vue';
import BaseBubble from 'next/message/bubbles/Base.vue';
import MessageMeta from '../MessageMeta.vue';
import InstagramTemplatePreview from 'dashboard/components-next/instagram/InstagramTemplatePreview.vue';
import { useMessageContext } from '../provider.js';
import { MESSAGE_VARIANTS, ORIENTATION } from '../constants.js';

const { contentAttributes, variant, orientation } = useMessageContext();

// The exact payload delivered to Instagram, stamped by
// Instagram::BaseSendService after a successful send.
const igTemplate = computed(() => contentAttributes.value?.igTemplate || {});

const metaAlignClass = computed(() =>
  orientation.value === ORIENTATION.RIGHT ? 'justify-end' : 'justify-start'
);

const metaColorClass = computed(() =>
  variant.value === MESSAGE_VARIANTS.PRIVATE
    ? 'text-n-amber-12/50'
    : 'text-n-slate-11'
);
</script>

<template>
  <div class="flex flex-col max-w-80">
    <BaseBubble
      hide-meta
      class="p-0 overflow-hidden"
      data-bubble-name="instagram-template"
    >
      <div class="flex flex-col gap-2 p-2.5">
        <InstagramTemplatePreview :content="igTemplate" />
        <MessageMeta :class="[metaAlignClass, metaColorClass]" />
      </div>
    </BaseBubble>
  </div>
</template>
